import { render, staticRenderFns } from "./LabTest.vue?vue&type=template&id=02b76f82&scoped=true"
import script from "./LabTest.vue?vue&type=script&lang=js"
export * from "./LabTest.vue?vue&type=script&lang=js"
import style0 from "./LabTest.vue?vue&type=style&index=0&id=02b76f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b76f82",
  null
  
)

export default component.exports